import store from '../store';
import { router } from '../router';
import Vue from 'vue'

export default class BasicService {
    constructor() {
        let url = process.env.NODE_ENV !== 'development' ? document.location.origin : 'http://51.75.37.170:2000';
        this.API_URL = url + '/api/';
    }

    getPremiumChannelId() {
        let currentRoute = router.history.current;
        return currentRoute.params.id ? currentRoute.params.id : store.state.auth.premiumChannel.id;
    }

    getApiUrl(withId = false) {
        return withId ? this.API_URL + this.getPremiumChannelId() + '/' : this.API_URL;
    }

    checkError(result) {
        return new Promise((resolve, reject) => {
            result.then(
                response => {
                    resolve(response);
                },
                error => {
                    if (error.response && error.response.status && error.response.status === 403) {
                        let err = "Undefinded error";

                        if (error.response && error.response.data && error.response.data.message)
                            err = error.response.data.message;
                        else if (error.message)
                            err = error.message;
                        else if (error.toString())
                            err = error.toString();

                        store.dispatch('auth/forbidden', err);
                        console.log(err);
                        router.push({name: 'login'});
                    } else {
                        let err = "Undefinded error";

                        if (error.response && error.response.data && error.response.data.message)
                            err = error.response.data.message;
                        else if (error.message)
                            err = error.message;
                        else if (error.toString())
                            err = error.toString();

                        Vue.swal.fire({
                            title: 'Error!',
                            text: err,
                            icon: 'error',
                            timer: 4000,
                            showConfirmButton: true,
                        });
                    }

                    reject(error);
                },
            )
        });
    }
}